import React, { useState } from 'react'
import { Button, Field, Flex, Modal, Text, Textarea } from '@workwhile/ui'
import { useBookingDetailsContextValue } from '../context/BookingDetailsProvider'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

const createWorkerSubmissionRequestFormSchema = z.object({
  reason: z.string().min(1, 'Reason is required'),
})

type CreateWorkerSubmissionRequestFormValues = z.infer<
  typeof createWorkerSubmissionRequestFormSchema
>

export const CreateWorkerSubmissionRequestButton = ({
  associationId,
}: {
  associationId: number
}) => {
  const {
    actions: { createWorkerSubmission },
    state: { workerSubmissionMutationState },
  } = useBookingDetailsContextValue()

  const [isOpen, setIsOpen] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CreateWorkerSubmissionRequestFormValues>({
    resolver: zodResolver(createWorkerSubmissionRequestFormSchema),
    defaultValues: {
      reason: '',
    },
  })

  const handleClick = () => {
    setIsOpen(true)
  }

  const onSubmit = handleSubmit((data) => {
    createWorkerSubmission({
      associationId,
      reason: data.reason,
    })
  })

  const handleCancel = () => {
    setIsOpen(false)
  }

  return (
    <>
      <Button
        variant="secondary"
        kind="small"
        onClick={handleClick}
        style={{ padding: '0 0.5rem' }}
        disabled={workerSubmissionMutationState.isPending}
        loading={workerSubmissionMutationState.isPending}
      >
        <Text fontSize="12px">Assign</Text>
      </Button>
      {isOpen ? (
        <Modal open onClose={handleCancel}>
          <Text mb={2}>
            Are you sure you want to create a worker submission for this worker?
            This request will be in a pending state in Dayforce until it is
            approved.
          </Text>
          <form onSubmit={onSubmit}>
            <Field label="Reason" error={errors.reason?.message}>
              <Textarea {...register('reason')} />
            </Field>

            <Flex flexDirection="row" justifyContent="space-between" gap={2}>
              <Button variant="secondary" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                type="submit"
                loading={workerSubmissionMutationState.isPending}
                disabled={workerSubmissionMutationState.isPending}
              >
                Submit
              </Button>
            </Flex>
          </form>
        </Modal>
      ) : null}
    </>
  )
}
